// GALERY PLACES
export const config = {
    formListSelector: '.popup__form',
    inputSelector: '.popup__input',
    inputErrorClass: 'popup__input-error_type_',
    errorClass: 'popup__input-error_active',
    submitButtonSelector: '.popup__button',
    inputBorderErrorClass: 'popup__input-error_border',
    inactiveButtonClass: 'popup__button_disabled'
};

export const profileEditButton = document.querySelector('.profile__edit-btn');
export const buttonEditAvatar = document.querySelector('.profile__edit-avatar');
export const profileAvatarBlock = document.querySelector('.profile__avatar-block')
export const popupInputUserName = document.querySelector('.popup__user-name');
export const popupInputOccupation = document.querySelector('.popup__occupation');
export const buttonNewItemOpen = document.querySelector('.profile__add-btn');
export const placesContainer = document.querySelector('.places');
export const formList = document.querySelectorAll('.popup__form');
